export default __webpack_public_path__ + "795112d9324eda2216c5bc2db04a3077.svg";